import {RemotePostBeneficiary} from 'data/usecases';
import {PostBeneficiary} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BeneficiaryEndpoints} from 'main/factories/usecases/endpoints';

export const makePostBeneficiary = (): PostBeneficiary =>
	new RemotePostBeneficiary(
		makeBFFApiUrl(BeneficiaryEndpoints.beneficiarySelection),
		makeAuthorizeHttpClientDecorator(),
	);
